import Swiper from 'swiper/bundle';

export default (scroller) => {
  if(document.querySelector('.media-slider__slider-block')){
    var swiperMedia = new Swiper(".media-slider__slider-block", {
      slidesPerView: 1,
      navigation: 'true',
      speed: 500,
      loop: false, 
      navigation: {
        nextEl: ".media-slider__button-next",
        prevEl: ".media-slider__button-prev",
      }

    });

    if(document.querySelector('.media-slider__video-item')){

      let mediaSliderItem = document.querySelectorAll('.media-slider__item');
      let modalVideo = document.getElementById('modal-video');
      let modalClose = modalVideo.querySelector('.modal__close');


      mediaSliderItem.forEach(item => {
        item.addEventListener('click', () => {
          modalVideo.classList.add('opened');
          header.classList.add('none');
        });
      });

      modalClose.addEventListener('click', () => {
        modalVideo.classList.remove('opened');
        header.classList.remove('none');
        restartVideoSlider();
      });

      var swiperVideo = new Swiper(".modal__slider-block", {
        slidesPerView: 1,
        navigation: 'true',
        speed: 500,
        loop: false, 
        navigation: {
          nextEl: ".modal__button-next",
          prevEl: ".modal__button-prev",
        }
  
      });

      swiperVideo.controller.control = swiperMedia;
      swiperMedia.controller.control = swiperVideo;

      swiperVideo.on('slideChange', function () {
        restartVideoSlider();
      });

      function restartVideoSlider(){
        let videos = document.querySelectorAll('.modal__video');
        videos.forEach((videoItem) => {
            var el_src = videoItem.getAttribute("src");
            videoItem.setAttribute("src",el_src);
        });
      }
    }



  }
}